import { type TransactionCause } from './transaction.types';

export enum WalletType {
  PLAYCOIN = 'PLAYCOIN',
  PREMIUM = 'PREMIUM',
  PREMIUM_365 = 'PREMIUM_365',
  TICKET = 'TICKET',
  NOT = 'NOT',
  TON = 'TON',
  XP = 'XP',
}

export interface Wallet {
  type: WalletType;
  balance: number;
  totalEarned: number;
  minAmountToWithdraw: number;

  activeBooster?: ActiveBooster | null;
  isExpiredBoosterExists?: boolean;

  data: null | Record<string, any>;
}

export interface ActiveBooster {
  id: number;
  value: number;
  activeTo: number;
  txCause?: TransactionCause | null;

  selectionKey?: string | null;
}

export interface ExpiredBooster {
  id: number;
  value: number;
  activeTo: number;
  totalProfit: number;
}

export interface WalletState {
  wallets: Wallet[] | undefined;
  pauseWalletWS: boolean;
}

export interface WalletStore extends WalletState {
  actions: WalletActions;
}

export interface WalletActions {
  hydrate: (
    partial:
      | ((state: Partial<WalletStore>) => Partial<WalletStore>)
      | Partial<WalletStore>
  ) => void;
  grabPrem90: () => Promise<void>;
  grabPrem365: () => Promise<void>;
  withdrawPrize: (prize: WalletType) => Promise<void>;

  hydrateWallet: (
    walletType: WalletType,
    wallet: ((wallet: Wallet) => Wallet) | Wallet
  ) => void;

  togglePauseWalletWS: (pauseWalletWS: boolean) => void;
  getWalletBalances: () => Record<WalletType, number>;
}
